import React from "react";
import HeaderSpacer from "../components/HeaderSpacer";
import Breadcrumbs from "../components/Breadcrumbs";
import passportCapsulePic from "../images/Exhibitions/passportCapsule-2026/sm/1_capsuleStaircase.webp";
import parisMetroPic from "../images/shop/Stockroom/parisMetro/sm/1_parisMetro.webp";
import italianRestaurantPic from "../images/shop/Stockroom/theItalianRestaurant/sm/1_italianRestaurant.webp";
import betootaPic from "../images/shop/Stockroom/sm/1_betootaHeights.jpg";
import optimist2Pic from "../images/shop/Stockroom/sm/2_theOptimistII.jpg";
import inflatableRocketPic from "../images/shop/Stockroom/untitledInflatableRocket/sm/1_untitledInflatableRocket.jpg";
import la5025Pic from "../images/shop/Stockroom/sm/03_la5025.jpg";
import millionYearsAgoPic from "../images/shop/Stockroom/sm/02_150millionYearsAgo.jpg";
import parisOriginalPic from "../images/shop/Stockroom/sm/1_parisOriginal.jpg";
import miniCapsulePic from "../images/shop/Stockroom/sm/1_10x10Capsule.jpg";
import abstractsCollectionPic from "../images/shop/Stockroom/sm/abstractsInstall.jpg";
import bordersSkiersSpritzersPic from "../images/shop/Stockroom/bordersSkiersSpritzers/sm/1_bordersSkiersSpritzers.jpg";
import pigeonsDogsNewYorkersPic from "../images/shop/Stockroom/pigeonsDogsNewYorkers/sm/1_pigeonsDogsNewYorkers.webp";
import driftingTogether2Pic from "../images/shop/Stockroom/driftingTogether2/sm/1_driftingTogether2.jpg";
import glenmoreRoadFiveWaysPic from "../images/shop/Stockroom/fiveWays/sm/1_fiveWays.webp";
import newYork42ndStPic from "../images/shop/Stockroom/newYork42ndSt/sm/1_42ndSt.webp";
import ImageLink from "../components/ImageLink3";
import SeriesHeader from "../components/SeriesHeader";
import UpButton from "./../components/UpButton";
import { Helmet } from "react-helmet-async";
// import AwayAlert from "../components/AwayMessage";


function PaintingShop() {
  return (
    <div>
      <Helmet>
        <title>Tyrone Layne | Shop | Paintings</title>
        <link rel='canonical' href='https://tyronelayne.com/painting-shop' />
      </Helmet>
      <HeaderSpacer />
      <Breadcrumbs />
      {/* <AwayAlert
        message="Attention- I'll be away from the studio September 28th-October 21st 2025. Any paintings
        ordered between these dates will be shipped once I
        return to Sydney."
      />*/}

      <section className='paintingSeries'>
        <SeriesHeader title='Peoplescapes' />
        <ImageLink
          source={italianRestaurantPic}
          description="Click to view 'The Italian Restaurant - 2026'"
          cssClass='italianRestaurantPic'
          linkTo='/painting-shop/TheItalianRestaurant'
          label='The Italian Restaurant'
          dimensions={"86cm x 102cm (34\" x 40\")"}
          medium="Oil & acrylic on linen"
          year="2026"
          price="$4,900"
        />
        <ImageLink
          source={parisMetroPic}
          description="Click to view 'Saint-Paul Metro, Paris - 2026'"
          cssClass='parisMetroPic'
          linkTo='/painting-shop/SaintPaulMetro'
          label='Saint-Paul Metro, Paris'
          dimensions={"25.5cm x 25.5cm (10\" x 10\")"}
          medium="Oil & acrylic on linen"
          year="2026"
          price="$850"
        />
        <ImageLink
          source={passportCapsulePic}
          description="Click to view the 'Passport Capsule Collection'"
          cssClass='passportCapsulePic'
          linkTo='/paintings/passport-capsule-2026'
          label='Passport Capsule Collection'
          year="10th July 2026"
        />
      </section>

      <section className='paintingSeries'>
        <SeriesHeader title='Landscapes' />
        <ImageLink
          source={driftingTogether2Pic}
          description="Click to view 'Drifting Together II - 2026'"
          cssClass='driftingTogether2Pic'
          linkTo='/painting-shop/DriftingTogether2'
          label='Drifting Together II'
          dimensions={"51cm x 45.5cm (20\" x 18\")"}
          medium="Oil on linen"
          year="2026"
          price="$1,950"
        />
        <ImageLink
          source={newYork42ndStPic}
          description="Click to view '42nd Street, New York - 2011/2013'"
          cssClass='newYork42ndStPic'
          linkTo='/painting-shop/NewYork42ndSt'
          label='42nd Street, New York'
          dimensions={"55cm x 45cm (22\" x 18\")"}
          medium="Oil on canvas"
          year="2011/2013"
          price="$2,100"
        />
      </section>

      <section className='paintingSeries'>
        <SeriesHeader title='Time Machine' />
        <ImageLink
          source={la5025Pic}
          description="Click to view 'los Angeles 5025- 2024'"
          cssClass='la5025Pic'
          linkTo='/painting-shop/LA5025Original'
          label='Los Angeles 5025'
          dimensions={"122cm x 152cm (48\" x 60\")"}
          medium="Oil on linen"
          year="2024"
          price="$8,250"
        />
        <ImageLink
          source={millionYearsAgoPic}
          description="Click to view '150 Million Years Ago- 2024'"
          cssClass='millionYearsAgoPic'
          linkTo='/painting-shop/MillionYearsAgoOriginal'
          label='150 Million Years Ago'
          dimensions={"122cm x 152cm (48\" x 60\")"}
          medium="Oil on linen"
          year="2024"
          price="$6,400"
        />
      </section>

      <section className='paintingSeries'>
        <SeriesHeader title='Abstracts' />
        <ImageLink
          source={abstractsCollectionPic}
          description="Click to view 'Abstracts collection'"
          cssClass='abstractsCollectionPic'
          linkTo='/painting-shop/abstracts'
          label='Abstract Paintings Collection 2019-2025'
        />
      </section>

      <section className='paintingSeries'>
        <SeriesHeader title='Sold' />
        <ImageLink
          source={glenmoreRoadFiveWaysPic}
          description="Click to view 'Glenmore Road FiveWays - 2026'"
          cssClass='glenmoreRoadFiveWaysPic'
          linkTo='/painting-shop/GlenmoreRoadFiveWays'
          label='Glenmore Road FiveWays'
          dimensions={"61cm x 56cm (24\" x 22\")"}
          medium="Oil on linen"
          year="2026"
          sold={true}
        />
        <ImageLink
          source={pigeonsDogsNewYorkersPic}
          description="Click to view 'Pigeons, Dogs, and New Yorkers - 2023/2026'"
          cssClass='pigeonsDogsNewYorkersPic'
          linkTo='/painting-shop/PigeonsDogsNewYorkers'
          label='Pigeons, Dogs, and New Yorkers'
          dimensions={"91cm x 86cm (36\" x 34\")"}
          medium="Oil & acrylic on linen"
          year="2023/2026"
          sold={true}
        />
        <ImageLink
          source={inflatableRocketPic}
          description="Click to view 'Untitled (Inflatable Rocket) - 2026'"
          cssClass='inflatableRocketPic'
          linkTo='/painting-shop/untitledInflatableRocket'
          label='Untitled (Inflatable Rocket)'
          dimensions={"30.5cm x 23cm (12\" x 9\")"}
          medium="Oil & acrylic on board"
          year="2026"
          sold={true}
        />
        <ImageLink
          source={bordersSkiersSpritzersPic}
          description="Click to view 'Borders, Skiers, and Spritzers - 2023/2026'"
          cssClass='bordersSkiersSpritzersPic'
          linkTo='/painting-shop/BordersSkiersSpritzers'
          label='Borders, Skiers, and Spritzers'
          dimensions={"91cm x 86cm (36\" x 34\")"}
          medium="Oil & acrylic on linen"
          year="2023/2026"
          sold={true}
        />
        <ImageLink
          source={optimist2Pic}
          description="Click to view 'The Optimist II- 2023/2024'"
          cssClass='optimist2Pic'
          linkTo='/painting-shop/Optimist2Original'
          label='The Optimist II'
          dimensions={"122cm x 102cm (48\" x 40\")"}
          medium="Oil & acrylic on linen"
          year="2023/2024"
          sold={true}
        />
        <ImageLink
          source={parisOriginalPic}
          description="Click to view 'Paris: A Moveable Feast- 2024'"
          cssClass='parisOriginalPic'
          linkTo='/painting-shop/ParisOriginal'
          label='Paris: A Moveable Feast'
          dimensions={"71cm x 71cm (28\" x 28\")"}
          medium="Oil & acrylic on linen"
          year="2024"
          sold={true}
        />
        <ImageLink
          source={miniCapsulePic}
          description="Click to view the '10inch x 10inch Capsule Release'"
          cssClass='miniCapsulePic'
          linkTo='/painting-shop/miniCapsuleOriginal'
          label='10inch x 10inch Capsule Series 2024'
          sold={true}
        />
        <ImageLink
          source={betootaPic}
          description="Click to view 'Betoota Heights 2022'"
          cssClass='betootaPic'
          linkTo='/painting-shop/betoota'
          label='Betoota Heights'
          dimensions={"61cm x 71cm (24\" x 28\")"}
          medium="Oil & acrylic on linen"
          year="2022"
          sold={true}
        />
      </section>

      <UpButton linkTo='/shop' />
    </div>
  );
}

export default PaintingShop;
